import request from '@/utils/request'

function post(url, param) {
  return request({
    url: `/deliveryControl/epms90a1/${url}`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param
  })
}

export const getShipNoList = param => post('getShipNoList', param)
export const getPorNoList = param => post('getPorNoList', param)
export const epms90a1List = param => post('epms90a1List', param)

export function epms90a1xls(param) {
  return post('epms90a1xls', param).then(res => {
    const binaryString = window.atob(res.body)
    const bytes = new Uint8Array(binaryString.length)
    for (let i = 0; i < binaryString.length; i++) bytes[i] = binaryString.charCodeAt(i)
    const blob = new Blob([bytes], { type: 'application/vnd.ms-excel' })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = 'Raw Material.xls'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(link.href)
  })
}
